import classNames from 'classnames/bind';
import React from 'react';

import { Button } from '@components/Button/Button';
import { Text } from '@components/Text/Text';
import { routes } from '@routes';

import styles from './SolutionList.module.scss';

const cx = classNames.bind(styles);

const items = [
  {
    title: 'Custom rules & configs',
    description:
      'Get the best possible performance with CDN specifically fine-tuned to your use case.',
  },
  {
    title: 'Flexible development',

    description:
      'Custom scenario? No problem, our in-house engineering team will get you up and running.',
  },
  {
    title: 'Dedicated CDN infrastructure',
    description:
      'CDN with dedicated cache space built specificaly for your needs including unique hardware or exclusive PoPs.',
  },
];

export const SolutionList: React.FC = () => (
  <div className={styles.contentWrapper}>
    <ul className={styles.list}>
      {items.map(({ title, description }) => (
        <li key="title" className={styles.texts}>
          <Text
            className={cx('title', 'mb-1')}
            color="gray100"
            display="block"
            size={18}
            tag="strong"
            weight="medium"
          >
            {title}
          </Text>
          <Text
            className={cx('description', 'mb-6')}
            color="white"
            display="block"
            opacity={80}
            size={16}
            tag="p"
          >
            {description}
          </Text>
        </li>
      ))}
    </ul>
    <div className={styles.buttonWrapper}>
      <Button href={routes.getStarted} theme="button" variant="primary">
        Talk to sales
      </Button>
    </div>
  </div>
);
